import { postAuthenticationNotificationToSlack } from "@web/api/auth"
import { useAuthState } from "@web/hooks/useAuthState"
import { useRouter } from "next/router"
import * as React from "react"

type RedirectArgs = {
  customRedirectUrl?: string
  isAutoLogin?: boolean
  skip?: boolean
  redirectTo?: string | null
}

export const useRedirectAfterLogin = ({ redirectTo, isAutoLogin, skip }: RedirectArgs) => {
  const router = useRouter()
  const { user } = useAuthState()
  const [isRedirecting, setIsRedirecting] = React.useState(false)

  React.useEffect(() => {
    // Block redirect, e.g. some task is in progress
    if (skip) return

    // User is not logged in (yet)
    if (!user) return

    // Tab is expected to close automatically in this case
    if (isAutoLogin && !redirectTo) return

    // handle "next" route after sign in
    let nextRoute: string

    if (redirectTo) nextRoute = redirectTo
    else if (router.query.callbackUrl) nextRoute = router.query.callbackUrl as string
    else nextRoute = "/dashboard/vacancy/list"

    postAuthenticationNotificationToSlack(nextRoute && `${window.location.origin}${nextRoute}`).catch(console.error)

    setIsRedirecting(true)
    router.replace(nextRoute).catch(console.error)
  }, [isAutoLogin, redirectTo, router, setIsRedirecting, skip, user])

  return { isRedirecting }
}
